import { type MatDateFormats } from '@angular/material/core';
import { type MatCalendarCell } from '@angular/material/datepicker';

import { type CalendarEvent } from '../myre-calendar/myre-calendar.interface';

export const MONTH_VIEW_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'yyyy',
  },
  display: {
    dateInput: 'yyyy',
    monthYearLabel: 'MMMM yyyy',
    dateA11yLabel: 'yyyy',
    monthYearA11yLabel: 'MMMM yyyy',
  },
};

export interface EventCalendarDay extends MatCalendarCell<Date> {
  dayWithMonth: string;
  events: CalendarEvent[];
  eventsToShow: CalendarEvent[];
  leftEventsNumber: number;
}
